import React from 'react';
import * as _ from 'lodash';
import { SEARCH_SKELETON_LENGTH } from '../search.constants';
import RectangularSkeleton from 'common/components/loaders/RectangularSkeleton';
import Skeleton from 'common/components/material/Skeleton';
import { Box } from 'common/components/material';

const SearchSkeletonView: React.FC = () => {
  return (
    <>
      {_.range(SEARCH_SKELETON_LENGTH).map((key) => (
        <RectangularSkeleton key={key} height="13.75rem" />
      ))}
    </>
  );
};

export const SearchSkeletonCompactView: React.FC = () => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
      {_.range(4).map((key) => (
        <Skeleton key={key} variant="rounded" width={'100%'} height={220} />
      ))}
    </Box>
  );
};

export default SearchSkeletonView;
